{
  "$id": "module://company-mapping",
  "$schema": "wealthlane://schemas/domain",
  "title": "Company Mapping",
  "type": "object",
  "properties": {
    "sourceCompanyId": {
      "type": "string",
      "title": "Source Company",
      "widget": "select",
      "actionId": "FETCH_CUSTOMER_SUCCESS_SOURCE_COMPANY_OPTIONS",
      "required": true
    },
    "destinationCompanyId": {
      "type": "string",
      "title": "Destination Company",
      "widget": "select",
      "actionId": "FETCH_CUSTOMER_SUCCESS_SOURCE_COMPANY_OPTIONS",
      "required": true
    }
  }
}
